<mat-select
  class="lum-select w-49"
  [ngClass]="{
    error: formControl?.invalid,
  }"
  [value]="formControl?.value"
  (selectionChange)="onSelectChange($event)"
>
  <mat-option
    *ngFor="let country of countries$ | async; trackBy: trackByValue"
    [value]="country?.key"
    >{{ country?.value }}</mat-option
  >
</mat-select>
